import React, { FC }      from "react";
import { useDispatch }    from "react-redux";
import { Button, Icon }   from "semantic-ui-react";
import Customer           from "../../../domain/customer/Customer";
import CustomerRepository from "../../../domain/customer/CustomerRepository";
import CustomerDataSource from "../../../infrastructure/datasource/customer/CustomerDataSource";
import RouterDispatcher   from "../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  customer: Customer;
}

const CustomerEditButton: FC<Props> = (props: Props) => {
  const repository: CustomerRepository = new CustomerDataSource(useDispatch());
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"

        onClick={ () => {
          repository.setCustomer(props.customer);
          routerDispatcher.customerEdit();
        } }
      >
        <Icon name="edit"/>
        編集する
      </Button>
    </>
  );
};

export default CustomerEditButton;